module.exports = __webpack_public_path__ + "static/img/invta_pc.35a03f19.png";